export default __webpack_public_path__ + "3ad5b7bd1395ce962bfad6f684e9aa67.png";